import { type AlertProps, Box, IconButton } from '@mui/material';
import React from 'react';
import { Icon, Text } from '@/components/ui';
import { closeAlertIcon } from '@/assets';

interface Props extends AlertProps {
  message: string;
}

export const Toast = React.forwardRef<HTMLDivElement, Props>(
  function Toast(props, ref) {
    const { color, message, onClose } = props;
    return (
      <Box
        ref={ref}
        sx={{
          minHeight: '2.1875rem', // 35px
          borderRadius: '1.25rem', // 20px
          bgcolor: `${color}.main`,
          position: 'relative',
        }}
      >
        <Box
          sx={{
            my: '0.625rem',
            ml: '0.9375rem',
            mr: '3.125rem',
            maxWidth: '21.875rem',
          }}
        >
          {' '}
          {/* 10px, 15px, 50px, 350px */}
          <Text
            sx={{
              fontSize: '1.125rem', // 18px
              lineHeight: '1.5625rem', // 25px
            }}
          >
            {message}
          </Text>
        </Box>

        <IconButton
          onClick={onClose}
          sx={{ position: 'absolute', top: '0.4375rem', right: '0.625rem' }} // 7px, 10px
        >
          <Icon src={closeAlertIcon} />
        </IconButton>
      </Box>
    );
  }
);
